import { FC } from 'react';
import { useConfigContext } from '@fe-core';
import { CreateAccount } from '@routes/selfreg/components/CreateAccount';
import { LoginAction } from './LoginAction';

type AuthorizationActionsPropsProps = {
  sessionId: string;
};

export const AuthorizationActions: FC<AuthorizationActionsPropsProps> = ({
  sessionId,
}) => {
  const { config } = useConfigContext();

  if (config.loggedIn) {
    return null;
  }

  return (
    <>
      <LoginAction />
      <CreateAccount sessionId={sessionId} />
    </>
  );
};
